import {
  Directive,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { map } from "rxjs/operators";
import { User } from "src/app/_models/User";
import { PermissionService } from "src/app/_services/permission.service";

@Directive({
  selector: "[hasPermission]",
})
export class PermissionDirective implements OnChanges {
  currentUser: User;
  private permissions = [];
  private logicalOp = "AND";
  private isHidden = true;

  @Input()
  set hasPermission(val: any[]) {
    this.permissions = val;
  }

  @Input()
  set hasPermissionOp(permop: string) {
    this.logicalOp = permop;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updateView();
  }

  private updateView() {
    this.permissionService
      .checkPermission(this.permissions, this.logicalOp)
      .subscribe((hasPermission) => {
        if (hasPermission) {
          if (this.isHidden) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.isHidden = false;
          }
        } else {
          this.isHidden = true;
          this.viewContainer.clear();
        }
      });
  }
}
